
import { Box, Card, CardActionArea, CardContent, CardMedia } from '@mui/material';
import Consolas from '../../../fonts/Consolas';
import { H3, H6, } from '../../../helper/constants';
import { CertCardProps } from './helper';
import React from "react"
import { optionalString } from '../../../helper/functions';
const CertCard = ({ title, date, certificate, cradential, img, alt }: CertCardProps): JSX.Element =>
(
    <Card sx={{ display: 'flex' }}>

        <a href={cradential}>
            <CardMedia
                component="img"
                sx={{ width: 151 }}
                image={img}
                alt={alt} />
        </a>
        <CardActionArea href={optionalString(certificate)}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flex: '1 0 auto' }}>
                    <Consolas as={H3}>{title}</Consolas>
                    <Consolas as={H6}> {date}</Consolas>
                </CardContent>
            </Box>
        </CardActionArea>

    </Card>
)

export default CertCard;
